import React, { Component } from "react";
import "./TopSlider.css";

let myInterval;

class ControlledCarousel extends React.Component {
  
  componentDidMount() {
    this.clickLoop();
  }

  clickLoop = () => {
    myInterval = setInterval(this.clickSlider, 10000);
  };

  clickSlider = () => {
    const nextBtn = document.getElementsByClassName("carousel-control-next")[0];
    nextBtn.click();
  };

  clearIntervalClick = () => {
    clearInterval(myInterval);
    this.clickLoop()
  }

  render() {
    return (
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-wrap="true"
        data-interval={false}
      >
        <ol className="carousel-indicators" onClick={()=> {
          this.clearIntervalClick();
        }}>
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            className="active"
          />
          <li data-target="#carouselExampleIndicators" data-slide-to="1" />
          <li data-target="#carouselExampleIndicators" data-slide-to="2" />
          <li data-target="#carouselExampleIndicators" data-slide-to="3" />
        </ol>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              className="d-block w-100 slider-img darken-img"
              src="../../images/logos/project_hero.jpg"
              alt="First slide"
            />
            <div className="carousel-caption main-brand">
              <div id="brand">
                We create a solid software foundation for your business
              </div>
              <div className="mission">
                We Are{" "}
                <img
                
                  id="team-page-logo"
                  src="../../images/logos/teamX_Logo-02.png"
                />
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img
              className="d-block w-100 slider-img darken-img"
              src="../../images/logos/server.jpg"
              alt="Second slide"
              id="security"
            />
            <div className="carousel-caption">
              <div className="slider-brand">
                Need help with IT Security? 
              </div>
              <p>We are a trusted cyber security partner for the US Government and many Fortune 500 companies around the world.</p>
            </div>
          </div>
          <div className="carousel-item">
            <img
              className="d-block w-100 slider-img darken-img"
              src="../../images/logos/cell.jpg"
              alt="Third slide"
            />
            <div className="carousel-caption">
              <div className="slider-brand">
                Building a mobile app? 
              </div>
              <p>Our team of Android, IOS, and React-Native specialists will take your product from idea to reality.</p>
            </div>
          </div>
          <div className="carousel-item">
            <img
              className="d-block w-100 slider-img darken-img"
              src="../../images/logos/cloud.jpg"
              alt="Fourth slide"
            />
            <div className="carousel-caption">
              <div className="slider-brand">
              Migrating to the Cloud?
              </div>
              <p>Accelerate migration to AWS, Azure, Google, and other cloud platforms with our cloud computing experts.</p>
            </div>
          </div>
        </div>
        <a
          className="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
          onClick={() => {
            this.clearIntervalClick();
          }}
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
          onClick={() => {
            this.clearIntervalClick();
          }}
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="sr-only">Next</span>
        </a>
      </div>
    );
  }
}

export default ControlledCarousel;



// WEBPACK FOOTER //
// ./src/components/Mainpage/TopSlider/TopSlider.js